var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0 13C0 5.8208 5.82031 0 13 0C20.1797 0 26 5.8208 26 13C26 20.1792 20.1797 26 13 26C5.82031 26 0 20.1792 0 13ZM24 13C24 6.92529 19.0752 2 13 2C6.9248 2 2 6.92529 2 13C2 19.0747 6.9248 24 13 24C19.0752 24 24 19.0747 24 13ZM18.6719 9.29102C18.2812 8.90137 17.6475 8.90332 17.2578 9.29443L11.4629 15.1182L8.70508 12.373L8.61133 12.29C8.21777 11.9863 7.65137 12.0151 7.29102 12.3765C6.90137 12.7681 6.90332 13.4009 7.29492 13.7905L10.7617 17.2417L10.8555 17.3247C11.249 17.6289 11.8164 17.5996 12.1758 17.2383L18.6758 10.7051L18.7588 10.6108C19.0625 10.2178 19.0342 9.65088 18.6719 9.29102Z",
    clipRule: "evenodd",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditAction);
export default __webpack_public_path__ + "static/media/ic_edit_action.a55a4bf708b72047fdcfc123dbdf8956.svg";
export { ForwardRef as ReactComponent };